import React, { useEffect, useState } from 'react';
import {
  DetailsContainer,
  ProfileImage,
  ImageContainer,
  ProfileCardContainerPL,
  ProfileImageStyled,
  ProfileLine,
  ProfileTitle,
} from '@atoms/dashboard/personalDashboard.styles';
import Avatar from 'react-avatar';
import { useRecoilValue } from 'recoil';
import { Current_User } from '@recoil/recoil';
import { ROLE_FULL_FORM } from '@constants/commonConstants';

const ProfileCard = data => {
  const [profileData, setProfileData] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [currentAssignedUser, setCurrentAssignedUser] = useState(null);
  const currentUser = useRecoilValue(Current_User);
  let imageBase64ToImage;

  useEffect(() => {
    let timeoutId; // eslint-disable-line

    if (data && data?.data && currentUser) {
      setProfileData(data?.data);

      if (data?.data?.photo !== null) {
        imageBase64ToImage = `data:image/jpg;base64,${data?.data?.photo}`;
        setImageSrc(imageBase64ToImage);
      }
    }

    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      const user = JSON.parse(localStorage.getItem('selectedUser'));
      setCurrentAssignedUser(user);
    }, 3000);
  }, [data, currentUser]);

  const getAvatarName = userName => {
    const nameArray = userName?.split(' ');
    const formattedName = nameArray && `${nameArray[0]} ${nameArray[nameArray.length - 1]}`;
    return formattedName;
  };

  return (
    profileData !== null && (
      <ProfileCardContainerPL>
        <ImageContainer>
          <ProfileImage>
            {imageSrc !== null ? <ProfileImageStyled src={imageSrc} alt="" /> : null}

            {imageSrc === null ? (
              <Avatar name={getAvatarName(profileData?.displayName)} size="100" round={true} />
            ) : null}
          </ProfileImage>
        </ImageContainer>
        <DetailsContainer>
          <ProfileTitle>{profileData.displayName}</ProfileTitle>
          {currentUser.role === 'PL' && currentAssignedUser !== null ? (
            <>
              <ProfileLine>{ROLE_FULL_FORM.PURSUIT_LEADER}</ProfileLine>
            </>
          ) : null}

          {currentUser.role === 'GCSP' && currentAssignedUser !== null ? (
            <>
              <ProfileLine>{ROLE_FULL_FORM.GCSP}</ProfileLine>
              <ProfileLine>{currentAssignedUser?.name}</ProfileLine>
            </>
          ) : null}

          {currentUser.role === 'MSL' && currentAssignedUser !== null ? (
            <>
              <ProfileLine>{ROLE_FULL_FORM.MARKET_SEGMENTS_LEADER}</ProfileLine>
              <ProfileLine>{currentAssignedUser?.name}</ProfileLine>
            </>
          ) : null}

          <ProfileLine>
            {profileData?.officeLocation === null
              ? profileData?.country
              : profileData?.country === null
                ? profileData?.officeLocation
                : `${profileData?.officeLocation}, ${profileData?.country}`}
          </ProfileLine>
        </DetailsContainer>
      </ProfileCardContainerPL>
    )
  );
};

export default ProfileCard;
